/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Method_ReverseInputs */

const cs_addr_method_reverse = /** @type {(inputs: Addr_Method_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RÚIAN · podle GPS`)
};

const en_addr_method_reverse = /** @type {(inputs: Addr_Method_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RÚIAN · from GPS`)
};

/**
* | output |
* | --- |
* | "RÚIAN · from GPS" |
*
* @param {Addr_Method_ReverseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_method_reverse = /** @type {((inputs?: Addr_Method_ReverseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Method_ReverseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_method_reverse(inputs)
	return cs_addr_method_reverse(inputs)
});